import React, { useEffect } from "react";
import * as Apihandler from "../../api/apiHandler";
import APISkeletonSVG from "../../assets/svg/APISkeletonSVG.svg";
import webhookSkeletonSVG from "../../assets/svg/webhookSkeletonSVG.svg";
import ApiDescriptor from "../components/apiDescriptor/apiDescriptor";
import ApiGroupDescriptor from "../components/apiGroupDescriptor/apiGroupDescriptor";
import BreadCrumbNav from "../components/breadcrumb/BreadcrumbNav";
import GetStarted from "../components/getStarted/getStarted";
import PropertyDescriptor, {
  Type,
} from "../components/propertyDescriptor/PropertyDescriptor";
import RequestResponseViewer, { WidgetType } from "../components/RequestResponse/RequestResponseViewer";
import { MenuItem } from "../components/side-menu/SideMenu";
import styles from "../pages/Styles/MainPage.module.scss";

interface MainPageProps {
  menu: MenuItem;
  setBreadCrumbConfig: (config: string[]) => void;
  activeItem: { item: MenuItem } | undefined;
}

const MainPage: React.FC<MainPageProps> = (props) => {
  const { menu, setBreadCrumbConfig, activeItem } = props;
  const [breadCrumbConfig, setLocalBreadCrumbConfig] = React.useState<string[]>([]);

  useEffect(() => {
    const config = menu?.path ? menu?.path?.split("/") : [];
    setBreadCrumbConfig(config);
    setLocalBreadCrumbConfig(config);
  }, [menu, activeItem, setBreadCrumbConfig]);

  const content: any = Apihandler.getContent(menu) ?? {
    name: "",
    description: "",
    url: "",
    method: "",
    headers: {},
    jsonRequest: {},
    jsonResponse: {},
    requestBody: {},
    responseBody: {
      data: [
        {
          name: "",
        },
      ],
    },
  };

  const isWebhookType = (content: any) => {
    return (content.webhookInfo != null || content.webhookInfo != undefined) ? true : false;
  }


  const getApiDescription = (content: any) => {
    const descriptionData = isWebhookType(content) ? { apiInfo: content?.webhookInfo, apiSpecifications: content?.webhookSpecifications } : content.apiInfo;
    return descriptionData;
  };


  console.log("apiInfo", content.apiInfo);
  console.log("content", content);
  console.log(activeItem)

  const documentationTypeMap: { [key: string]: 'API Guide' | 'Webhooks Guide' | 'API Errors' | 'Webhook Errors' | 'Authentication Guide' | 'Rate Limiting' } = {
    'Overview-REST APIs/Guides': 'API Guide',
    'Overview-Webhooks/Guides': 'Webhooks Guide',
    'Errors-REST APIs/Guides': 'API Errors',
    'Errors-Webhooks/Guides': 'Webhook Errors',
    'Overview-REST APIs/Authentication': 'Authentication Guide',
    'Rate Limiting-REST APIs/Guides': 'Rate Limiting',
  };

  const documentationType = activeItem?.item ? documentationTypeMap[`${activeItem.item.title}-${activeItem.item.path}`] : null;

  if (documentationType) {
    return (
      <div className={styles.mainPage}>
        <div className="row">
          <BreadCrumbNav breadcrumbs={breadCrumbConfig} />
        </div>
        <GetStarted type={documentationType} />
      </div>
    );
  }

  return (
    <div className={styles.mainPage}>
      <div className="row">
        <BreadCrumbNav breadcrumbs={breadCrumbConfig} />
      </div>
      <div className="row">
        <div className="col-md-6 col-lg-6">
          <div>
            <ApiGroupDescriptor
              title={content.webhookInfo ? breadCrumbConfig[1] : breadCrumbConfig[2]}
              productName={breadCrumbConfig[1]}
              type={content.webhookInfo ? 'Webhook' : 'API'}
            />
          </div>
          <div>
            <ApiDescriptor
              title={content?.name}
              description={getApiDescription(content)}
            />
          </div>
        </div>
        <div className={`${styles.leftContainer} col-md-6 col-lg-6`}>
          <div className={styles.skeletonImageContainer}>
            <img
              className={styles.skeletonImage}
              src={content.webhookInfo ? webhookSkeletonSVG : APISkeletonSVG}
              alt="webpage skeleton"
            />
          </div>
          {content.webhookInfo ? (
            <RequestResponseViewer
              webhookResponseJson={content.jsonResponse}
              widgetType={WidgetType.Webhook}
              isCollapsable={true}
              title={{ titleName: content.name }}
            />
          ) :
            <RequestResponseViewer
              curlRequestCommand={content.jsonRequest}
              curlResponseCommand={content.jsonResponse}
              widgetType={WidgetType.ApiRequestResponse}
              isCollapsable={true}
              url={content.url}
              method={content.method}
            />}
        </div>
      </div>
      {content.webhookInfo ? (
        <div className="row mt-4">
          <PropertyDescriptor
            value={content.responseBody}
            type={Type.WebHookResponse}
          ></PropertyDescriptor>
        </div>
      ) : (
        <>
          {content.headers && <div className="row mt-4">
            <PropertyDescriptor
              value={content.headers}
              type={Type.ApiRequest}
              isHeaderParameter={true}
            ></PropertyDescriptor>
          </div>}
          {content.requestBody && <>
            <div className="row mt-4">
              <PropertyDescriptor
                value={content.requestBody}
                type={Type.ApiRequest}
              ></PropertyDescriptor>
            </div>
          </>
          }
          {content.responseBody && <>
            <div className="row mt-4">
              <PropertyDescriptor
                value={content.responseBody}
                type={Type.ApiResponse}
              ></PropertyDescriptor>
            </div>
          </>
          }
        </>
      )}
      <br />
    </div>
  );
};

export default MainPage;
